<template>
    <div class="deals-header">
        <div class="deals-header__title">
            Сортировать объекты
        </div>

        <div class="deals-header__columns">
            <div class="deals-header__column mobile-hide">
                ID
            </div>
            <div class="deals-header__column mobile-hide">
                Телефон клиента
            </div>
            <div :class="['deals-header__column', {'is-active': sort.projectName.active }]"
                 @click="$emit('changeSort', 'projectName')">
                Проект
                <div class="deals-header__icon">
                    <SortLetterDown v-if="sort.projectName.order === 'desc'" />
                    <SortLetterUp v-if="sort.projectName.order === 'asc'" />
                </div>
            </div>
            <div :class="['deals-header__column', {'is-active': sort.objectCost.active }]"
                 @click="$emit('changeSort', 'objectCost')">
                Стоимость
                <div class="deals-header__icon">
                    <SortNumberDown v-if="sort.objectCost.order === 'desc'" />
                    <SortNumberUp v-if="sort.objectCost.order === 'asc'" />
                </div>
            </div>
            <div :class="['deals-header__column', {'is-active': sort.newStatusName.active }]"
                 @click="$emit('changeSort', 'newStatusName')">
                Статус
                <div class="deals-header__icon">
                    <SortLetterDown v-if="sort.newStatusName.order === 'desc'" />
                    <SortLetterUp v-if="sort.newStatusName.order === 'asc'" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SortLetterDown from '@/blocks/DealsBlock/DealsHeader/icons/SortLetterDown';
import SortLetterUp from '@/blocks/DealsBlock/DealsHeader/icons/SortLetterUp';
import SortNumberDown from '@/blocks/DealsBlock/DealsHeader/icons/SortNumberDown';
import SortNumberUp from '@/blocks/DealsBlock/DealsHeader/icons/SortNumberUp';

export default {
    name: 'DealsHeader',

    components: {
        SortLetterDown,
        SortLetterUp,
        SortNumberDown,
        SortNumberUp
    },

    props: {
        sort: Object
    },
};
</script>

<style lang="scss">
@import "DealsHeader";
</style>
